module.exports = __webpack_public_path__ + "static/media/surfing_1024.af896280.jpg";